import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children, allowedRole }) {
    const role = localStorage.getItem("jodiPointRole");

    // No login
    if (!role) {
        return <Navigate to="/login" replace />;
    }

    // Wrong role
    if (allowedRole && role !== allowedRole) {
        return <Navigate to="/login" replace />;
    }

    return children;
}

export default ProtectedRoute;